<template>
  <div>
    <px-view-header title="Categorias"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-listagem-grupo-header :on-click-refresh="onClickRefresh"
                              :on-change-filter="onChangeFilter" />
    <px-grupo-lista :grupos="grupos"
                    :loading="loading"
                    :on-change-options="onChangeOptions"
                    :options-list="optionsList"
                    :footer-options="footerOptions"
                    @remove="onRemove" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-grupos/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import GruposService from './grupos-service';
import ListaGrupo from './ListaGrupo.vue';
import ListagemGrupoHeader from './ListagemGrupoHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Produtos' },
        { text: 'Categorias' },
      ],
      grupos: {
        content: [],
        total: 0,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemGrupos', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemGrupos', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getGrupos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getGrupos();
    },
    onClickRefresh() {
      this.getGrupos();
    },
    onRemove(item) {
      this.loading = true;
      GruposService.remover(item.id)
        .then(() => {
          this.$toast('Grupo removido com sucesso', { color: 'success' });
          this.getGrupos();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getGrupos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return GruposService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.grupos = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxGrupoLista: ListaGrupo,
    pxListagemGrupoHeader: ListagemGrupoHeader,
  },
};

</script>
